import { Link } from 'react-router-dom';

import { getInfo, TruncateWithTooltipFormatter } from '@Components/Grid/components/Table/formatters';

export default function UserLinkFormatter({ info }) {
  const { row } = getInfo(info)
  const { id, first_name } = row.user || {}

  if (id && first_name) {
    return <Link className='twy-text-base-accent hover:underline' to={`/settings/users/${id}`}>
      <TruncateWithTooltipFormatter value={`[#${id}] - ${first_name}`} />
    </Link>
  }

  return '--'
}
